/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentDetailTranscriptionQueryResponse, WebAppGetFragmentDetailTranscriptionPathParams, WebAppGetFragmentDetailTranscription401, WebAppGetFragmentDetailTranscription403, WebAppGetFragmentDetailTranscription404 } from "../models/WebAppGetFragmentDetailTranscription";

export function getWebAppGetFragmentDetailTranscriptionUrl(id: WebAppGetFragmentDetailTranscriptionPathParams["id"]) {
  const res = { method: 'GET', url: `/web-app/v1/fragments/${id}/transcription` as const }
  return res
}

/**
 * @summary Get fragment transcription
 * {@link /web-app/v1/fragments/:id/transcription}
 */
export async function webAppGetFragmentDetailTranscription(id: WebAppGetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<WebAppGetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailTranscription401 | WebAppGetFragmentDetailTranscription403 | WebAppGetFragmentDetailTranscription404>, unknown>({ method : "GET", url : getWebAppGetFragmentDetailTranscriptionUrl(id).url.toString(), ... requestConfig })
  return res.data
}